var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("block-with-checks"),
      _vm._v(" "),
      _c("compare-sect-v2", { attrs: { background: "background-grey" } }),
      _vm._v(" "),
      _c("old-new-way"),
      _vm._v(" "),
      _c("review"),
      _vm._v(" "),
      _c("faq-new"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("city-part", { attrs: { background: "background-img" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vafrfor-section background-none" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-md-11" }, [
            _c("div", { staticClass: "titles" }, [
              _c("h5", { staticClass: "med-max p-dgrey mb-0 p-bold" }, [
                _vm._v("Varför använda TecknaEl.se?")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", { staticClass: "min-min p-black" }, [
                _vm._v(
                  "\n                            Vi hjälper översättningsbyråer, fraktleverantörer, webbyråer, betalningslösningar eller andra aktörer som vill hitta flera ehandlare som kunder. Det kan även finnas behov att hitta branschstatistik, för att säkerhetställa att det byggs rätt tjänst till en marknad där det finns potential. Det finns även möjlighet att köpa unika rapporter som är speciellt anpassade efter er frågeställning mot Sveriges ehandlare.\n                        "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "min-min p-black" }, [
                _vm._v(
                  "Som abonnemangsinnehavare hos oss får ni alltid tillgång till uppdaterad data, detta är ett bra verktyg för trendbevakning och säkerhetsställa att ni agerar på rätt data. Vill ni analysera datan själva så finns det även möjlighet att med leverantörs-abonnemanget exportera datan.\n                        "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "min-min p-black" }, [
                _vm._v(
                  "Strategi, trend, analys, vi hjälper er veta vilken leverantör som växer snabbast på den svenska marknaden. Detta kan spara er mycket tid, genom att rikta rätt fokus till rätt typ av kund som kan nyttja just era tjänster.\n                        "
                )
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }